import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import MyUnits from './pages/Hotels/MyUnits';
import AvailabilityCalendar from './pages/Hotels/AvailabilityCalendar';
import Orders from './pages/Bookings/Orders';
import VerifyBooking from './pages/Bookings/VerifyBooking';
import ExtraServices from './pages/Hotels/ExtraServices';
import Reviews from './pages/Reviews/Reviews';
import SettingsPage from './pages/Settings/Settings';
import Login from './pages/Auth/Login';
import DeleteAccount from './pages/Auth/DeleteAccount';
import Navbar from './components/layout/Navbar/Navbar';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const AppContent = () => {
  const location = useLocation();
  const isPublicPage = location.pathname === '/login' || location.pathname === '/delete-account';

  return (
    <div className="App">
      {!isPublicPage && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        
        {/* Protected Routes */}
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/listings" element={<ProtectedRoute><MyUnits /></ProtectedRoute>} />
        <Route path="/availability" element={<ProtectedRoute><AvailabilityCalendar /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
        <Route path="/reviews" element={<ProtectedRoute><Reviews /></ProtectedRoute>} />
        <Route path="/verify" element={<ProtectedRoute><VerifyBooking /></ProtectedRoute>} />
        <Route path="/services" element={<ProtectedRoute><ExtraServices /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <Router basename="/">
      <AppContent />
    </Router>
  );
}

export default App;
